import theme from "themes/Theme";
import { IconProps } from "./IconProps";
const AccordionUpIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = theme.palette.primary.main,
}) => {
  return (
    <svg
      fill="none"
      height={height}
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      width={width}
    >
      <path
        d="M6 15L12 9L18 15"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default AccordionUpIcon;
